// eslint-disable-next-line @typescript-eslint/no-deprecated
export const isApple = /Mac|iPhone|iPad/.test(navigator.platform)

// eslint-disable-next-line @typescript-eslint/no-deprecated
export const isMac = navigator.platform.toLocaleLowerCase().includes("mac")

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)